import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalComponent } from '../../../../config/core.modal-helpers';
import { AdminService } from '../../../../services/core.admin.service';
import { UiService } from '../../../../services/core.ui.service';

import * as _ from 'lodash-es';

@Component({
    selector: 'trove-add-modal',
    template: `<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="close" (click)="doCancel()" aria-hidden="true">&times;</button>
        <h2 *ngIf="! parent" translate>Add Category</h2>
        <h2 *ngIf="parent" translate>Add Subcategory to {{parent.title}}</h2>
    </div>
    <div class="modal-body clearfix">
        <trove-content [category]="category"></trove-content>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="doCancel()" translate>Cancel</button>
        <button class="btn btn-primary" (click)="submit()" [disabled]="!valid()">
            <span translate>Save</span>
        </button>
    </div>
</div>`
})
export class TroveAddModalComponent extends ModalComponent implements OnInit {

    @Input() parent: any = null;

    @Output() onClose = new EventEmitter<boolean>();

    protected category: any = {};

    constructor(
        private adminService: AdminService,
        private uiService: UiService,
    ) { super(); }

    ngOnInit() {
        this.category = {
            parentCategoryId: this.parent.id,
            alias: '',
            categoryName: '',
            description: '',
            showInSearch: 'N',
            accessLevel: '0'
        };
    };

    valid() {
        return this.category.alias != '' && this.category.categoryName != '' && this.category.description != '';
    }

    doClose() {
        this.close.emit(true);
    };

    doCancel() {
        this.close.emit(false);
    };

    submit() {
        var submitting = this.category;
        // submitting.showInSearch = submitting.showInSearch ? 'Y' : 'N';
        this.adminService.postTrove(_.get(submitting, 'id', 0), submitting)
            .then(() => {
                this.doClose();
                this.uiService.message.showSuccess('Added new category ' + submitting.categoryName);
            }, () => {
                this.uiService.message.showError('Failed to create category ' + submitting.categoryName);
            })
    };
}